import { z } from 'zod';
import { refineTableName } from '../Refines';

export const BronzeDataSourceSchema = z
  .object({
    name: z
      .string({
        required_error: 'Name is required',
      })
      .refine(...refineTableName),
    format: z.string().optional(),
    schema: z.enum(['file', 'hints', 'hintsFile']).optional(),
    schemaFile: z.string().optional(),
    schemaHintsFile: z.string().optional(),
    schemaHints: z.string().optional(),
    skip: z.boolean(),
    location: z.string().optional(),
  })
  .refine(
    (data) => {
      if (!data.skip) {
        return !!data.format;
      }
      return true;
    },
    { message: 'Format is required', path: ['format'] },
  )
  .refine(
    (data) => {
      if (!data.skip) {
        return !!data.location;
      }
      return true;
    },
    { message: 'Location is required', path: ['location'] },
  );

export type BronzeDataSourceSchemaValues = z.infer<
  typeof BronzeDataSourceSchema
>;
